import { useCallback, useMemo } from 'react';
import throttle from 'lodash/throttle';
import { useEffectSound } from './sound';
import Assets from '../assets/Assets';

const DEFAULT_THROTTLE_WAIT = 2_000;

type TCallback = (...args: any[]) => void;

const useThrottledCallback = (
	callback: TCallback,
	wait = DEFAULT_THROTTLE_WAIT
): TCallback => {
	return useMemo(() => {
		return throttle(callback, wait, { leading: true, trailing: false });
	}, [callback, wait]);
};

type TOptionalCallback = (() => void) | undefined;

const useClickCallback = (
	onClick: TOptionalCallback,
	soundEnabled: boolean,
	soundVolume: number
): TOptionalCallback => {
	const play = useEffectSound(Assets.sounds.bubble, soundEnabled, soundVolume);

	const onClickWithSound = useCallback((): void => {
		if (onClick) {
			play();
			onClick();
		}
	}, [onClick, play]);

	const onClickThrottleWithSound = useThrottledCallback(onClickWithSound);

	return onClick ? onClickThrottleWithSound : undefined;
};

export { useThrottledCallback, useClickCallback };
